<template>
  <Modal
    :id="'cmp-distribution-shop_groups-add_shop_group'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $dft.snakeCaseToWords("shop_group") }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            class="m1"
            :id="'shops_group'"
            required
            v-bind="textFieldConfig"
            :placeholder="$t('shops_group')"
            :value="shops_groupData.shops_group"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          />
          <Dropdown
            class="m2"
            :id="'channel'"
            :options="channelTV"
            :placeholder="$t('channel')"
            :selected="channelTV.find(e => e.value == shops_groupData.channel)"
            @selectedChange="e => onDropdownChange('channel', e)"
            v-bind="requiredDropdownConfig"
            @validated="e => onDropdownValidated('channel', e)"
            box
          ></Dropdown>
          <Dropdown
            class="m2"
            :id="'shop_group_type'"
            :options="GroupTypeTV"
            :placeholder="$t('shop_group_type')"
            :selected="
              GroupTypeTV.find(e => e.value == shops_groupData.group_type)
            "
            @selectedChange="e => onDropdownChange('group_type', e)"
            box
          ></Dropdown>
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        class="dt-button v1 s6"
        @click.stop="onOkClick"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
      >
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { Shop_groupsService } from "../../services/shop_groups.service";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    Modal,
    TextField
  },
  props: ["list"],
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true
      },

      requiredDropdownConfig: {
        required: true,
        immediateValidation: true,
        showValidationIcons: true
      },

      validationResult: {},

      shops_groupData: this.getShopsGroup()
    };
  },
  computed: {
    channelTV: function() {
      return [
        { text: "Digital", value: "digital" },
        { text: "Physical", value: "physical" },
        { text: "Thirdparty", value: "thirdparty" },
        { text: "Performance", value: "performance" }
      ];
    },
    GroupTypeTV: function() {
      // return [
      //   { text: "General", value: "general" },
      //   { text: "Special", value: "special" }
      // ];
      return [{ text: "General", value: 1 }, { text: "Special", value: 2 }];
      // return createTV(this.list, "group_type", "shop_group_id");
    },
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    }
  },
  methods: {
    onTextFieldValueChange: function(name, value) {
      this.shops_groupData[name] = value;
    },
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
    },
    onDropdownValidated(name, value) {
      this.$set(this.validationResult, name, value);
    },

    onDropdownChange(name, value) {
      console.log("onDropdownChange ", name, value);
      this.shops_groupData[name] = value.value;
    },

    onOkClick: async function() {
      const res = await Shop_groupsService.addShopGruop(
        this.shops_groupData.shops_group,
        this.shops_groupData.group_type,
        this.shops_groupData.channel
      );
      console.log("Ok clicked", res.data.shop_group_id);
      this.$emit("added", res.data.shop_group_id);
    },

    onCancel: function() {
      this.$emit("cancelled", true);
    },

    getShopsGroup: function() {
      return {
        shops_group: null,
        channel: null,
        group_type: null
      };
    }
  }
};
</script>

<style></style>
